import { useTranslation } from 'react-i18next';

import { TemplatesCard } from '@/features/template-manage';
import { SettingsShell } from '@/features/settings-shell';

import styles from './AccountPage.module.css';

/** Settings -> Templates: the account's own task and column templates. */
export function TemplatesPage() {
  const { t } = useTranslation();
  return (
    <SettingsShell>
      <div className={styles.page}>
        <h1 className={styles.title}>{t('templates.manage.title')}</h1>
        <section className={styles.card}>
          <TemplatesCard />
        </section>
      </div>
    </SettingsShell>
  );
}
